import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-todo1',
  template: `
    <p>
      todo1 works!
    </p>
  `,
  styles: [
  ]
})
export class Todo1Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
